export default "__VITE_ASSET__Dz7jemC1__"